<template>
  <div>
    <div>买家姓名：{{record.shippingAddress.name}}</div>
    <div>买家电话：{{record.shippingAddress.phone}}</div>
    <div>收货地址：{{$tkRegions.getFullName(record.shippingAddress.region) + ' ' + record.shippingAddress.address}}</div>
  </div>
</template>
<script>
export default {
  props: {
    record: Object, // 当前行的数据
    model: Object, // 当前model对象
    field: Object, // 当前field对象
    viewTitle: {
      type: String,
      default: '查看'
    }
  }
}
</script>
